import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import axios from 'axios';
import Qs from 'qs';
import _ from 'lodash';
import {createBrowserHistory} from 'history';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import {CircularProgress} from '@material-ui/core';
import {AES, enc} from 'crypto-js';
import moment from 'moment-timezone';
import {v4 as uuidv4} from 'uuid';
import {Path} from 'path-parser';

import PasswordReset from 'components/PasswordReset';
import SuspenseSpinner from 'components/SuspenseSpinner';
import Router from 'components/Router';
import UpdateOldAccount from 'components/Auth/UpdateOldAccount';
import {ROUTES} from 'components/Router/routes';
import 'assets/global.css';
import Context from 'utils/Context';
import {login, logout} from 'utils/auth.service';
import {getGeoloc, getCountry, refreshGeoloc} from 'utils/Geoloc';
import Conf from 'utils/Conf';
import Utils from 'utils/Utils';
import Ed from 'utils/EventDispatcher';
import Theme from 'utils/Theme';

import './App.scss';

const theme = createTheme(Theme);

let uuid;
const storageAvailable = Utils.storageAvailable('localStorage');
if (storageAvailable) {
  let storage = window.localStorage;
  let storageUuid = storage.getItem('uuid');
  if (!storageUuid) {
    uuid = uuidv4();
    storage.setItem('uuid', uuid);
  } else {
    uuid = storageUuid;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      geoloc: null,
      country: null,
      time: moment().unix(),
      visited: [],
      modele: {},
      appState: {
        displayLocalTimezone: false,
        query: {},
        updatingGeoloc: false,
        conf: {
          LANGS: [],
          // RETARD_MAX: 5,
        },
        user: {},
        volume: 1,
        currentVolume: 1,
        ready: false,
        canDisplayNews: true,
        tick: 0,
        uuid,
      },
      passwordResetOpen: false,
      updateOldAccountOpen: false,
    };
    this.ed = new Ed();
    this.history = createBrowserHistory({basename: ''});
    this.methods = {
      setEmail: this.setEmail.bind(this),
      setAppState: this.setAppState.bind(this),
      getProfile: this.fetchProfile,
      logout: this.logout.bind(this),
      login: this.login.bind(this),
      mailCheck: this.mailCheck.bind(this),
      updateProfile: this.updateProfile.bind(this),
      refreshGeoloc: this.refreshGeoloc,
      tick: this.tick.bind(this),
    };
  }
  componentDidMount() {
    // CHECK URL FOR EMBEDED LIMITATIONS
    let currentParams = null;
    _.find(ROUTES, r => {
      let path = new Path(r.url);
      currentParams = path.test(window.location.pathname);
      return currentParams;
    });
    if (currentParams && currentParams.tag) this.filterTag = currentParams.tag.trim();
    else {
      let filterTag = this.getQueryParameter('filterTag');
      if (filterTag) {
        this.filterTag = filterTag.trim();
        this.goTo('/');
      }
    }
    // END CHECK URL FOR EMBEDED LIMITATIONS

    this.hasOldProfile();

    this.fetchConfiguration();
    getGeoloc().then(geoloc => {
      this.geolocTimer = true;
      this.setState(state => ({
        geoloc,
        appState: {
          ...state.appState,
          ready: true,
        },
      }));
    });
    getCountry().then(country => {
      this.setState({
        country,
      });
    });
    this.fetchModele();
    this.fetchProfile();

    // this.interval = setInterval(this.updateMesSeances, 10000);
    this.interval = setInterval(() => this.setState({time: moment().unix()}), 10000);
    window.addEventListener('resize', this.resize);
    this.resize();
    const query = Qs.parse(window.location.search, {ignoreQueryPrefix: true});
    if (query.action && query.action === 'password_reset') {
      this.setState({passwordResetOpen: true, passwordSelector: query.selector, passwordToken: query.token});
      this.goTo('/');
    } else {
      this.goTo(window.location.pathname);

      this.setState({
        appState: {
          ...this.state.appState,
          query,
        },
      });
    }
    document.body.addEventListener('click', this.makeRequestWithUserGesture);
    this.props.i18n.on('languageChanged', this.handleLanguageChanged);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    window.removeEventListener('resize', this.resize);
    document.body.removeEventListener('click', this.makeRequestWithUserGesture);
    this.props.i18n.off('languageChanged', this.handleLanguageChanged);
  }
  handleUpdateOldAccountClose = () => {
    this.setState({updateOldAccountOpen: false});
  };
  handleUpdateOldAccountOpen = () => {
    this.setState({updateOldAccountOpen: true});
  };
  setEmail(email, cb) {
    const newUser = {
      ...this.state.appState.user,
      email,
    };
    this.setState(
      {
        appState: {
          ...this.state.appState,
          user: newUser,
        },
      },
      () => cb && cb(),
    );
    let ciphertext = AES.encrypt(JSON.stringify(newUser), Conf.gpsSecret).toString();
    localStorage.setItem('user', ciphertext);
  }
  setAppState(s) {
    let appState = {...this.state.appState, ...s};
    this.setState({appState: appState});
  }
  tick() {
    let appState = this.state.appState;
    appState.tick++;
    this.setState({appState});
  }
  refreshGeoloc = async () => {
    this.setState({
      appState: {
        ...this.state.appState,
        updatingGeoloc: true,
      },
    });
    const newGeoloc = await refreshGeoloc();
    this.setState({
      geoloc: newGeoloc || this.state.geoloc,
      appState: {
        ...this.state.appState,
        updatingGeoloc: false,
      },
    });
  };
  getFilteredModele = () => {
    const {modele, geoloc, appState, time, country} = this.state;
    if (!geoloc) return modele;
    const {latitude, longitude, accuracy} = geoloc;

    const {cinemas, films, seances} = modele;

    const localisationOk = Boolean(latitude && longitude);
    if (!localisationOk) {
      return modele;
    }

    const modifiedSeances = (seances || []).map(seance => {
      const startTime = moment.tz(seance.start_time, seance.zone_name);
      return {
        ...seance,
        tzStartTime: startTime.format(),
        local: Utils.isSeanceLocal(seance, geoloc, country),
        cantBuy: startTime.unix() < time - appState.conf.DUREE_ACHAT * 60,
        ended: startTime.unix() < time - Conf.dureeSeance * 3600,
      };
    });

    const modifiedCinemas = (cinemas || [])
      .map(cinema => {
        const distance = Utils.getDistance(latitude, longitude, cinema.latitude, cinema.longitude) - accuracy / 1000;
        const isInSameCountry = cinema.pays.some(p => p.id === country);
        const hasALocalShow = modifiedSeances.some(seance => seance.cinema_id === cinema.cinema_id && seance.local);
        return {
          ...cinema,
          local: hasALocalShow,
          radius: cinema.distance,
          isInSameCountry,
          distance,
        };
      })
      .sort(Utils.compareCinemas);

    const modifiedFilms = (films || [])
      .map(f => ({
        ...f,
        local: f.nb_seances > 0 && modifiedSeances.some(s => s.film_id === f.film_id && s.local),
      }))
      .sort(Utils.compareFilms);
    if (this.geolocTimer) {
      this.geolocTimer = false;
    }
    return {
      ...modele,
      films: modifiedFilms,
      cinemas: modifiedCinemas,
      seances: modifiedSeances,
    };
  };
  fetchConfiguration = () => {
    axios
      .get(Conf.apiBaseUriLegacy + '/conf', {
        params: {},
        withCredentials: true,
      })
      .then(res => {
        this.setState({
          appState: {
            ...this.state.appState,
            conf: res.data,
          },
        });
      });
  };
  fetchModele = async () => {
    const params = {
      lang: this.props.i18n.language,
    };
    if (this.filterTag) {
      params.filterTag = this.filterTag;
    }
    const result = await axios.get(`${Conf.apiBaseUriLegacy}/accueil`, {params, withCredentials: true});
    this.setState({
      modele: result.data,
    });
    return result.data;
  };
  fetchProfile = cb => {
    axios.get(Conf.apiBaseUriLegacy + '/user/profile', {withCredentials: true}).then(({data}) => {
      this.setState(
        {
          appState: {
            ...this.state.appState,
            user: data,
          },
        },
        () => {
          this.ed.trigger('userUpdate');
          cb && cb();
        },
      );
    });
  };
  logout(cb) {
    const symfonyLogout = logout();
    const legacyLogout = axios.post(Conf.apiBaseUriLegacy + '/user/logout', Qs.stringify({}), {withCredentials: true});

    Promise.all([symfonyLogout, legacyLogout]).then(res => {
      this.fetchProfile(() => {
        // this.updateMesSeances();
        cb();
      });
    });
  }

  login(email, password, cb) {
    const symfonyLogin = login(email, password);

    const legacyLogin = axios.post(Conf.apiBaseUriLegacy + '/user/login', Qs.stringify({email, password}), {
      withCredentials: true,
    });

    Promise.all([symfonyLogin, legacyLogin]).then(([symfonyData, {data}]) => {
      this.fetchProfile(() => {
        // this.updateMesSeances();
        cb(data);
      });
    });
  }
  updateProfile(user, cb) {
    let data = _.cloneDeep(user);
    data._method = 'PATCH';
    axios.post(Conf.apiBaseUriLegacy + '/user/profile', Qs.stringify(data), {withCredentials: true}).then(() => {
      this.fetchProfile(cb);
    });
  }
  mailCheck(email, cb) {
    return axios
      .post(Conf.apiBaseUriLegacy + '/user/exists', Qs.stringify({email: email}), {withCredentials: true})
      .then(res => cb(res.data));
  }
  hasOldProfile = () => {
    let user;
    if (storageAvailable) {
      let ciphertext = localStorage.getItem('user');
      if (ciphertext) {
        let bytes = AES.decrypt(ciphertext, Conf.gpsSecret);
        user = JSON.parse(bytes.toString(enc.Utf8));
      }
      let ciphertextNew = localStorage.getItem('geoloc');
      if (!ciphertextNew && user) {
        if (user.email) {
          this.setState(
            {
              appState: {
                ...this.state.appState,
                oldEmail: user.email,
              },
            },
            () => {
              this.mailCheck(user.email, res => {
                if (!res) this.handleUpdateOldAccountOpen();
              });
            },
          );
        }
      }
    }
  };
  makeRequestWithUserGesture = () => {
    if (document.requestStorageAccess) {
      document.requestStorageAccess().then(
        () => {
          // Storage access was granted.
          document.body.removeEventListener('click', this.makeRequestWithUserGesture);
        },
        () => {
          // Storage access was denied.
          document.body.removeEventListener('click', this.makeRequestWithUserGesture);
        },
      );
    }
  };
  resize = () => {
    let widthClass = 'xs';
    let appState = this.state.appState;
    if (window.innerWidth >= 600) widthClass = 'sm';
    if (window.innerWidth >= 960) widthClass = 'md';
    if (window.innerWidth >= 1280) widthClass = 'lg';
    if (window.innerWidth >= 1920) widthClass = 'xl';
    widthClass !== 'xs' && document.body.classList.remove('xs');
    widthClass !== 'sm' && document.body.classList.remove('sm');
    widthClass !== 'md' && document.body.classList.remove('md');
    widthClass !== 'lg' && document.body.classList.remove('lg');
    widthClass !== 'xl' && document.body.classList.remove('xl');
    document.body.classList.add(widthClass);
    appState.screenSize = widthClass;
    this.setState({appState: appState}, () => setTimeout(this.methods.tick, 500));
  };
  handleLanguageChanged = lang => {
    axios
      .post(
        Conf.apiBaseUriLegacy + '/user/lang',
        Qs.stringify({
          lang,
          _method: 'PATCH',
        }),
        {withCredentials: true},
      )
      .then(() => {
        this.fetchModele();
        this.fetchProfile();
      });
  };
  handlePasswordResetClose = () => {
    this.setState({passwordResetOpen: false});
  };
  goTop(scrollY = 0) {
    setTimeout(() => window.scrollTo(0, scrollY), 1);
  }
  goTo = url => {
    if (url.indexOf('http://') >= 0 || url.indexOf('https://') >= 0) window.open(url, '_blank');
    else if (this.filterTag && !url.startsWith('/e/')) {
      url = '/e/' + this.filterTag + url;
    } else if (window.location.pathname.startsWith('/c/') && !url.startsWith('/c/')) {
      const match = window.location.pathname.match(/^\/c\/(\d+)/);
      if (match) {
        const prefixCinemaId = match[1];
        url = `/c/${prefixCinemaId}${url}`;
      }
    }
    this.history.push(url);
  };
  getQueryParameter(name) {
    const url = window.location.href;

    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  getModifiedUserSeances = () => {
    const {appState, time} = this.state;
    if (!appState.user.mes_seances) return appState.user.mes_seances;
    return appState.user.mes_seances.map(seance => ({
      ...seance,
      ended: moment.tz(seance.start_time, seance.zone_name).unix() < time - Conf.dureeSeance * 3600,
    }));
  };
  render() {
    const {
      updateOldAccountOpen,
      passwordResetOpen,
      passwordSelector,
      passwordToken,
      geoloc,
      country,
      modele,
    } = this.state;
    const {t} = this.props;
    if (!modele) {
      return <SuspenseSpinner />;
    }
    const modifiedModele = this.getFilteredModele();
    const appState = {
      ...this.state.appState,
      user: {
        ...this.state.appState.user,
        mes_seances: this.getModifiedUserSeances(),
      },
    };

    const context = {
      history: this.history,
      goTo: this.goTo,
      modele: modifiedModele,
      appState,
      methods: this.methods,
      ed: this.ed,
      geoloc,
      country,
    };

    return (
      <Context.Provider value={context}>
        <ThemeProvider theme={theme}>
          {geoloc && <Router />}
          {!geoloc && (
            <div className="geoloc-wait">
              <div>
                <CircularProgress />
                <p>{t('en-attente-de-localisation')}</p>
              </div>
            </div>
          )}
          <UpdateOldAccount
            methods={this.methods}
            appState={appState}
            open={updateOldAccountOpen}
            onClose={this.handleUpdateOldAccountClose}
          />
          <PasswordReset
            methods={this.methods}
            open={passwordResetOpen}
            onClose={this.handlePasswordResetClose}
            selector={passwordSelector}
            token={passwordToken}
          />
        </ThemeProvider>
      </Context.Provider>
    );
  }
}

export default withTranslation()(App);
